module.exports = __webpack_public_path__ + "img/666.0cfec518.png";